import { render } from "./_PortfolioNews.vue?vue&type=template&id=3c79d0f4&scoped=true"
import script from "./_PortfolioNews.vue?vue&type=script&lang=js"
export * from "./_PortfolioNews.vue?vue&type=script&lang=js"

import "./_PortfolioNews.vue?vue&type=style&index=0&id=3c79d0f4&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c79d0f4"]])

export default __exports__